import React from "react";
import {
  TableContentDetail,
  TableContentRow,
  TableHeader,
  WalletTableContainer,
} from "../styledUserWalletComponentGlobal";

function UserWalletWithdrawReportsComponent({ data }) {
  return (
    <WalletTableContainer>
      <TableHeader>
        <td>مبلغ</td>
        <td>تاریخچه</td>
        <td>بابت</td>
        <td>مانده موجودی</td>
      </TableHeader>
      <TableContentRow>
        <TableContentDetail isWithdraw>10000</TableContentDetail>
        <TableContentDetail>15:10 1400-02-01</TableContentDetail>
        <TableContentDetail>خرید اشتراک</TableContentDetail>
        <TableContentDetail>10000</TableContentDetail>
      </TableContentRow>{" "}
      <TableContentRow>
        <TableContentDetail isWithdraw>10000</TableContentDetail>
        <TableContentDetail>15:10 1400-02-01</TableContentDetail>
        <TableContentDetail>خرید اشتراک</TableContentDetail>
        <TableContentDetail>10000</TableContentDetail>
      </TableContentRow>{" "}
    </WalletTableContainer>
  );
}

export default UserWalletWithdrawReportsComponent;
